const messageRouters = [
  // 信息中心
  {
    path: 'message',
    name: 'Message',
    redirect: '/manage/message/list',
    component: () => import(/* webpackChunkName: "Message" */ '@/views/content'),
    meta: {
      sidebar: false,
      // 可查看用户列表的权限
      authKey: ['auth_message'],
      title: 'message_center',
      disabled: false,
      icon: 'message',
    },
    children: [
      // 消息中心 - 列表
      {
        path: 'list',
        name: 'MessageList',
        component: () => import(/* webpackChunkName: "MessageList" */ '@/views/message/list'),
        meta: {
          sidebar: false,
          authKey: ['auth_message', 'auth_message_list'],
          breadcrumb: false,
          title: 'message_center',
          disabled: false,
          icon: 'message',
        },
      },
      // 消息接收管理
      {
        path: 'setting',
        name: 'MessageSetting',
        component: () =>
          import(/* webpackChunkName: "MessageSetting'," */ '@/views/message/setting'),
        meta: {
          sidebar: false,
          authKey: ['auth_message', 'auth_message_setting'],
          title: 'message_admin',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
    ],
  },
];

export default messageRouters;
